import Member from 'src/entities/Member';

import Environment from '../common/Environment';
import MemberJson from '../jsons/MemberJson';

export default class InviteMember {
  execute(member: Member, account: Member): Promise<Member> {
    const method: string = 'POST';
    const path = Environment.server() + '/member/invite';

    return new Promise((resolve, reject) => {
      fetch(path, {
        method,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          member,
          account
        })
      })
        .then(response => {
          if (response.ok) {
            return response.json();
          } else {
            reject(response.status);
            return null;
          }
        })
        .then((responseJson: MemberJson) => {
          if (
            responseJson.api === undefined ||
            responseJson.api.status === undefined
          ) {
            reject('Server Error');
          } else if (responseJson.api.status === 'success') {
            resolve(responseJson.member);
          } else {
            reject(responseJson.api.errorMessage);
          }
        })
        .catch(error => {
          console.log(error.message);
          reject(`Unable to reach server.\n${error.message}`);
        });
    });
  }
}



// WEBPACK FOOTER //
// ./src/apis/InviteMember.ts